import { Inbox, FilterX, AlertCircle } from "lucide-react";
import styles from "./EmptyState.module.css";

const VARIANTS = {
  "no-data": {
    Icon: Inbox,
    title: "No patients yet",
    subtitle: "Patients assigned to this location will appear here.",
  },
  filtered: {
    Icon: FilterX,
    title: "No patients match your filters",
    subtitle: "Try clearing search or filters to see all patients.",
  },
  error: {
    Icon: AlertCircle,
    title: "Couldn't load patients",
    subtitle: "Something went wrong. Please try again.",
  },
};

const EmptyState = ({ variant, action }) => {
  const config = VARIANTS[variant] || VARIANTS["no-data"];
  const { Icon, title, subtitle } = config;

  return (
    <div
      className={styles.container}
      role="status"
      aria-live="polite"
    >
      <Icon className={styles.icon} aria-hidden="true" size={48} />
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.subtitle}>{subtitle}</p>
      {action && (
        <button
          type="button"
          className={styles.action}
          onClick={action.onClick}
        >
          {action.label}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
